export default __webpack_public_path__ + "static/media/inner_page_header.402dd2fa.png";